export const defaultOptions = {
    zx: 0,
    maxNumColors: 256,
    dither: 1.0,
};
